import React from 'react';
import { CheckCircle2, Download, ArrowRight, Star } from 'lucide-react';
import { CTAButton } from '../components/ui/CTAButton';
export function ThankYouPage() {
  return <div className="min-h-screen bg-gray-50 font-sans text-gray-900 selection:bg-rose-200 selection:text-rose-900 pb-12" data-id="element-456">
      {/* Success Header */}
      <div className="bg-green-600 text-white py-4 px-4 text-center shadow-md" data-id="element-457">
        <div className="flex items-center justify-center gap-2 font-bold text-lg" data-id="element-458">
          <CheckCircle2 className="h-6 w-6" data-id="element-459" />
          ¡Tu acceso está confirmado!
        </div>
        <p className="text-green-100 text-sm mt-1" data-id="element-460">
          Hemos enviado tus accesos a tu correo electrónico.
        </p>
      </div>

      <main className="max-w-4xl mx-auto px-4 py-8 md:py-12" data-id="element-461">
        {/* What You Bought Summary */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 mb-10" data-id="element-462">
          <h2 className="text-lg font-bold text-gray-900 mb-4 border-b border-gray-100 pb-2" data-id="element-463">
            Resumen de tu compra:
          </h2>
          <div className="flex flex-col sm:flex-row gap-6 items-start sm:items-center" data-id="element-464">
            <div className="flex -space-x-4" data-id="element-465">
              <img src="https://cdn.magicpatterns.com/uploads/6mHR95aYqiKteTwzfHgtr4/ChatGPT_Image_31_ene_2026,_03_36_32_p.m..png" className="w-16 h-20 object-cover rounded shadow-md border-2 border-white" alt="Ebook" data-id="element-466" />
              <img src="https://cdn.magicpatterns.com/uploads/nBHycezXfKtJw92fLEEpgw/portada_bono_1.png" className="w-16 h-20 object-cover rounded shadow-md border-2 border-white" alt="Bono 1" data-id="element-467" />
            </div>
            <div className="flex-1" data-id="element-468">
              <h3 className="font-bold text-gray-800" data-id="element-469">
                Pack Completo: Di Esto, No Aquello™
              </h3>
              <p className="text-sm text-gray-500" data-id="element-470">
                Incluye Ebook + 3 Bonos de Regalo
              </p>
              <div className="flex items-center gap-2 mt-2 text-xs font-medium text-green-600 bg-green-50 px-2 py-1 rounded w-fit" data-id="element-471">
                <CheckCircle2 className="h-3 w-3" data-id="element-472" /> Acceso Inmediato
              </div>
            </div>
          </div>
          <div className="mt-4 bg-blue-50 text-blue-700 px-4 py-3 rounded-xl flex items-center gap-3 text-sm font-medium" data-id="element-473">
            <span className="text-lg" data-id="element-474">📩</span>
            Revisa tu correo electrónico — te enviamos un email con el link de
            descarga y tus accesos.
          </div>
        </div>

        {/* UPSELL SECTION */}
        <div className="text-center mb-8" data-id="element-475">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2" data-id="element-476">
            Espera... completa tu experiencia
          </h2>
          <p className="text-gray-600" data-id="element-477">
            Oportunidad única para nuevas estudiantes. No disponible
            públicamente.
          </p>
        </div>

        <div className="max-w-md mx-auto" data-id="element-478">
          {/* Upsell - Relationship Scripts Vault */}
          <div className="bg-white rounded-2xl shadow-lg border border-rose-100 overflow-hidden flex flex-col" data-id="element-479">
            <div className="bg-rose-50 p-4 text-center border-b border-rose-100" data-id="element-480">
              <span className="text-xs font-bold text-rose-600 uppercase tracking-widest" data-id="element-481">
                Más Vendido
              </span>
              <h3 className="text-xl font-bold text-gray-900 mt-1" data-id="element-482">
                Relationship Scripts Vault™
              </h3>
            </div>
            <div className="p-6 flex-1 flex flex-col items-center" data-id="element-483">
              <img src="https://cdn.magicpatterns.com/uploads/3So4tN9PBhmbP9bSUAHiUj/ChatGPT_Image_8_feb_2026,_02_28_41_p.m..png" alt="Relationship Scripts Vault™" className="w-32 h-44 object-cover rounded-lg shadow-md mb-5" data-id="element-484" />
              <p className="text-gray-600 text-sm mb-6 text-center" data-id="element-485">
                ¿Quieres tener la frase correcta para cada situación? Accede a
                nuestra biblioteca privada con más de 100 scripts para dating,
                vida en pareja, discusiones difíciles y establecimiento de
                límites.
              </p>
              <ul className="space-y-2 mb-6 text-sm text-gray-700 w-full" data-id="element-486">
                <li className="flex gap-2" data-id="element-487">
                  <CheckCircle2 className="h-4 w-4 text-rose-500 flex-shrink-0" data-id="element-488" />{' '}
                  100+ Scripts listos para usar
                </li>
                <li className="flex gap-2" data-id="element-489">
                  <CheckCircle2 className="h-4 w-4 text-rose-500 flex-shrink-0" data-id="element-490" />{' '}
                  Para toda etapa de relación
                </li>
                <li className="flex gap-2" data-id="element-491">
                  <CheckCircle2 className="h-4 w-4 text-rose-500 flex-shrink-0" data-id="element-492" />{' '}
                  Formato móvil amigable
                </li>
              </ul>
              <div className="mt-auto w-full" data-id="element-493">
                <div className="text-center mb-4" data-id="element-494">
                  <span className="text-3xl font-bold text-gray-900" data-id="element-495">
                    $17.99
                  </span>
                  <span className="text-gray-400 line-through text-sm ml-2" data-id="element-496">
                    $97
                  </span>
                </div>
                <CTAButton fullWidth className="text-sm py-3" onClick={() => window.open('https://pay.hotmart.com/G104366208D?bid=1770690537488', '_blank')} data-id="element-497">
                  Agregar a mi compra
                </CTAButton>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-12" data-id="element-498">
          <button onClick={() => window.location.hash = ''} className="text-gray-400 text-sm hover:text-gray-600 underline transition-colors" data-id="element-499">
            No gracias, iré al inicio
          </button>
        </div>
      </main>
    </div>;
}